import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Basketball({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M12.6666 22.6462C18.0266 22.3156 22.3156 18.0267 22.6461 12.6666H22.6666V11.3333H22.6461C22.302 5.75283 17.6671 1.33331 11.9999 1.33331C6.10888 1.33331 1.33325 6.10894 1.33325 12C1.33325 17.6671 5.75277 22.302 11.3333 22.6462V22.6666H12.6666V22.6462ZM6.02355 4.8307C4.13159 6.40957 2.87423 8.72329 2.69003 11.3333H11.3333V6.64578C9.39377 6.52402 7.58489 5.87461 6.02355 4.8307ZM12.6666 6.64578V11.3333H21.3098C21.1256 8.72329 19.8682 6.40957 17.9763 4.8307C16.415 5.87461 14.6061 6.52402 12.6666 6.64578ZM11.3333 12.6666H2.69003C2.87423 15.2767 4.1316 17.5904 6.02355 19.1693C7.58489 18.1254 9.39377 17.4759 11.3333 17.3542V12.6666ZM12.6666 17.3542V12.6666H21.3098C21.1256 15.2767 19.8682 17.5904 17.9763 19.1693C16.4149 18.1254 14.6061 17.4759 12.6666 17.3542ZM11.3333 18.6905C9.84671 18.7974 8.44541 19.2594 7.19701 20.0043C8.4211 20.7404 9.82789 21.2036 11.3333 21.3099V18.6905ZM12.6666 21.3099V18.6905C14.1531 18.7974 15.5544 19.2594 16.8028 20.0043C15.5787 20.7404 14.1719 21.2036 12.6666 21.3099ZM12.6666 5.30942V2.69009C14.1719 2.79633 15.5787 3.25956 16.8028 3.99564C15.5544 4.74052 14.1531 5.20252 12.6666 5.30942ZM11.3333 2.69009V5.30942C9.84672 5.20252 8.44541 4.74052 7.19701 3.99564C8.4211 3.25956 9.82789 2.79633 11.3333 2.69009Z"
        fill={iconColor}
      />
    </Svg>
  );
}
